import enquire from 'enquire.js'
import MediaQueryActionCreators from './MediaQueryActionCreators'


/*
*
$grid-breakpoints: (
  xs: 0,
  sm: 576px,
  md: 768px,
  lg: 992px,
  xl: 1200px
) !default;*/
const MediaQueryRegistration = {
  register: (store) => {
    enquire.register('screen and (max-width: 991px)', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('isMobile', true))
      },
      // Unmatch function is called when media query is false
      unmatch: () => {
        // dispatch unmatch events
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('isMobile', false))
      }
    })
    enquire.register('screen and (max-width: 575px)', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('breakpoint', 'xs'))
      }
    })
    enquire.register('screen and (min-width: 576px) and (max-width: 767px)', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('breakpoint', 'sm'))
      }
    })
    enquire.register('screen and (min-width: 768px) and (max-width: 991px)', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('breakpoint', 'md'))
      }
    })
    enquire.register('screen and (min-width: 992px) and (max-width: 1199px)', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('breakpoint', 'lg'))
      }
    })
    enquire.register('screen and (min-width: 1200px) ', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('breakpoint', 'xl'))
      }
    })
    enquire.register('screen and (max-width: 991px)', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('hasMobileMenu', true))
      },
      // Unmatch function is called when media query is false
      unmatch: () => {
        // dispatch unmatch events
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('hasMobileMenu', false))
      }
    })
    enquire.register('screen and (min-width: 1400px)', {

      // Match function is called when the query is true
      match: () => {
        // dispatch match event
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('extraLarge', true))
      },
      // Unmatch function is called when media query is false
      unmatch: () => {
        // dispatch unmatch events
        store.dispatch(MediaQueryActionCreators.matchMediaQuery('extraLarge', false))
      }
    })
  }
}

export default MediaQueryRegistration



// WEBPACK FOOTER //
// ./src/redux-modules/media-query/MediaQueryRegistration.js